import React, { Component } from 'react';
import Navigation from '../components/Navigation';
import { translate } from 'react-i18next';
import CreateFactTypeForm from '../components/CreateFactTypeForm';
import axios from 'axios';
import { Panel, Col, Row, Button, FormControl, Form } from 'react-bootstrap';
import PlainPanel from '../components/PlainPanel';
import config from '../config';
import { Link } from 'react-router-dom';

import './CreateFactType.css';

class CreateFactType extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'CreateFactType.title'
        )}`;

        return (
            <div className="CreateFactType">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <div className="row">
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('CreateFactType.title')}
                                </h1>

                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-info" />{' '}
                                        <Link to={`/facts`}>
                                            {t('Facts.title')}
                                        </Link>
                                    </li>
                                    <li>
                                        <i className="fa fa-list" />{' '}
                                        <Link to={`/facts/facttypes`}>
                                            {t('FactTypes.title')}
                                        </Link>
                                    </li>
                                    <li className="active">
                                        <i className="fa fa-plus" />{' '}
                                        {t('CreateFactType.title')}
                                    </li>
                                </ol>

                                <PlainPanel>
                                    <CreateFactTypeForm />
                                </PlainPanel>
                            </Col>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(CreateFactType);
